import { imageUrl } from 'app/frontend/base/helpers'
import { raidMarkerTypes } from 'app/frontend/types/custom/RaidMarker'

type NoteTooltipContentProps = {
  text: string
}

const markerTokenPattern = /\{([a-z]+)\}/g

const NoteTooltipContent = ({ text }: NoteTooltipContentProps) => {
  const parts: Array<
    { type: 'text'; value: string } | { type: 'marker'; value: string }
  > = []
  let lastIndex = 0
  let match = markerTokenPattern.exec(text)

  while (match) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', value: text.slice(lastIndex, match.index) })
    }
    const marker = match[1]
    if (raidMarkerTypes.includes(marker as typeof raidMarkerTypes[number])) {
      parts.push({ type: 'marker', value: marker })
    } else {
      parts.push({ type: 'text', value: match[0] })
    }
    lastIndex = match.index + match[0].length
    match = markerTokenPattern.exec(text)
  }

  if (lastIndex < text.length) {
    parts.push({ type: 'text', value: text.slice(lastIndex) })
  }

  return (
    <div className='max-w-72 flex items-center gap-0.5 flex-wrap justify-center'>
      {parts.map((part, index) =>
        part.type === 'marker' ? (
          <img
            key={`${part.value}-${index}`}
            src={imageUrl(`markers/${part.value}.png`)}
            className='h-3.5 w-3.5 shrink-0'
          />
        ) : (
          <span key={index}>{part.value}</span>
        ),
      )}
    </div>
  )
}

export default NoteTooltipContent
